<template>
  <p v-if="!hasLost" id="lives">Vidas {{ hearts }}</p>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  lives: number
  totalLives: number
  hasLost?: boolean
  infiniteMode?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  hasLost: false,
  infiniteMode: false,
})

const hearts = computed((): string => {
  // Show infinity symbol for infinite mode
  if (props.infiniteMode) {
    return '∞'
  }

  const fullHearts = Math.floor(props.lives)
  const fractional = props.lives - fullHearts
  const hasHalfHeart = fractional >= 0.5 ? 1 : 0

  const halfHeartSymbol = '💔'
  const redHearts = '❤️'.repeat(fullHearts)
  const halfHeart = hasHalfHeart ? halfHeartSymbol : ''

  const usedHearts = fullHearts + hasHalfHeart
  const whiteHeartsCount = Math.max(props.totalLives - usedHearts, 0)
  const whiteHearts = '🤍'.repeat(whiteHeartsCount)

  return redHearts + halfHeart + whiteHearts
})
</script>

<style scoped>
#lives {
  color: black;
  display: flex;
  justify-content: center;
  font-size: 24px;
  margin: 15px;
}
</style>
